import {Carousel} from "./carousel.js";
import {positionBetween, roundToNearest} from "./utils.js";

/**
 * Control scroll
 */
export class ScrollController{
    private animate = (() =>{
        if(this.scrollByUserData || this.scrollToProgrammable || this.hovered)
            return;
        this.scrollToByProgram(this.currentScroll - this.carousel.blocksCountInRow * this.carousel.blockWidth);

    });
    private animateTimeout!: any;
    constructor(private readonly carousel: Carousel, private readonly scrollTimeMs: number=900, public animationTimeoutTime = 7000) {
        this.updateTimeout();
    }
    public hovered: Boolean = false;
    public scrollByUserData?: { when: number; startXPos: number } = undefined;
    private _currentScroll: number = 0;
    public get currentScroll(){return this._currentScroll;}
    private set currentScroll(v){this._currentScroll = v;}
    private scrollToProgrammable?: {to: number; when: number; from: number} = undefined;

    public end(delta: number, final: boolean=true){
        this.currentScroll += delta;
        // const deltaSpeed = delta / (+new Date - this.scrollByUserData!.when);
        this.scrollByUserData = undefined;
        if(final) {
            if(Math.abs(delta) > 100){
                const scrollElements = delta*3; // Math.max(delta * 3, deltaSpeed * 300);
                this.scrollToByProgram(this.roundPosition(this.currentScroll + scrollElements));
            }
            else this.scrollToByProgram(this.roundPosition(this.currentScroll));
        }
    };
    private roundPosition(position: number){
        return roundToNearest(position, this.carousel.blockWidth)
    }

    public scrollToByProgram(where: number){
        this.scrollToProgrammable = {to: where, when: +new Date, from: this.currentScroll};
        this.updatePosition();
    }
    startMove(pageX: number, when: number = +new Date) {
        this.scrollToProgrammable = undefined;
        this.scrollByUserData = {when: when, startXPos: pageX};
    }
    updatePosition(){
        if(this.scrollByUserData || !this.scrollToProgrammable) return;
        const isFinishOne = (+new Date) >= this.scrollToProgrammable.when + this.scrollTimeMs;
        const progress = isFinishOne?1:Math.min(1, ((+new Date) - this.scrollToProgrammable.when) / this.scrollTimeMs);
        this.currentScroll = positionBetween(
            this.scrollToProgrammable.from,
            this.scrollToProgrammable.to,
            progress
        )
        this.carousel.scrollX(this.currentScroll);
        if(!isFinishOne)
            requestAnimationFrame(()=>this.updatePosition());
        else {
            this.scrollToProgrammable = undefined;
            this.updateTimeout();
        }
    }

    scrollPrev() {
        const delta = this.carousel.blocksCountInRow * this.carousel.blockWidth;
        const startScroll = this.scrollToProgrammable?.to ?? this._currentScroll
        this.scrollToByProgram(delta + startScroll);
    }
    scrollNext() {
        const delta = -this.carousel.blocksCountInRow * this.carousel.blockWidth;
        const startScroll = this.scrollToProgrammable?.to ?? this._currentScroll
        this.scrollToByProgram(delta + startScroll);

    }
    public updateTimeout(){
        clearTimeout(this.animateTimeout);
        this.animateTimeout = setTimeout(this.animate, this.animationTimeoutTime)
    }
}
